var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDuplicate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19392"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgba(0,0,0,0)",
  d: "M16 0A16 16 0 1 1 0 16 16 16 0 0 1 16 0",
  "data-name": "Path 27348"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 15461"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 28V4H4v24Z",
  "data-name": "Path 5191",
  opacity: 0.01
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 15208"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.269 17.084v2.654c0 3.538-1.415 4.954-4.954 4.954H11.95c-3.538 0-4.954-1.415-4.954-4.954v-3.361c.004-3.539 1.419-4.954 4.954-4.954h2.657",
  "data-name": "Path 5206"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.438 17.084c-2.123 0-2.831-.708-2.831-2.831v-2.83l5.661 5.661Z",
  "data-name": "Path 5207"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.492 7h3.538",
  "data-name": "Path 5208"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.423 9.65A2.65 2.65 0 0 1 14.077 7h2.321",
  "data-name": "Path 5209"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.692 12.307v5.475a2.49 2.49 0 0 1-2.486 2.486",
  "data-name": "Path 5210"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.038 12.307c-1.991 0-2.654-.663-2.654-2.657V7l5.307 5.307Z",
  "data-name": "Path 5211"
}))))));
export { SvgDuplicate as ReactComponent };
export default __webpack_public_path__ + "static/media/duplicate.67f21735d310ae73da7fb006c045c032.svg";